import { render } from "./DialogScreenGRColor.vue?vue&type=template&id=eb6ed256&scoped=true"
import script from "./DialogScreenGRColor.vue?vue&type=script&lang=js"
export * from "./DialogScreenGRColor.vue?vue&type=script&lang=js"

import "./DialogScreenGRColor.vue?vue&type=style&index=0&id=eb6ed256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6ed256"]])

export default __exports__